import { render } from "./ReviewRequestView.vue?vue&type=template&id=6b9f4247&ts=true"
import script from "./ReviewRequestView.vue?vue&type=script&lang=ts"
export * from "./ReviewRequestView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__